const { parseUrlValue, setUrlValue } = require('./url-helpers.js');

export default() => ({
	selected_types: [],
	ready: false,
	popping: false,
	types: [],
	init() {
		this.types = JSON.parse( this.$refs.data.textContent );
		this.parseUrl();
		// this.$nextTick( () => this.parseUrl() );
		this.setupWatches();
	},
	parseUrl() {
		const types = parseUrlValue('type');
		if ( types ) {
			this.selected_types = types;
			this.$nextTick( () => this.$dispatch('filter', { field: 'type', types }) );
		}

		this.ready = true;
	},
	popstate() {
		const state = this.$event.state;
		this.popping = true;
		if ( state === null ) {
			this.selected_types = [];
		} else {
			if ( state.type ) {
				this.selected_types = state.type;
			} else {
				this.selected_types = [];
			}
		}
		this.$nextTick( () => this.popping = false );
	},
	clearFilters() {
		this.selected_types = [];
	},
	markUnavailableTypes() {
		const available_types = this.$event.detail;
		// console.log('available types: ', available_types);
		for( let i = 0; i < this.types.length; i++ ) {
			this.types[i]['unavailable'] = !available_types.includes(this.types[i].slug);
		}
	},
	setupWatches() {
		this.$watch(
			'selected_types',
			value => {
				if ( !this.ready) { return; }

				if ( !this.popping ) {
					setUrlValue('type', value);
				}
				this.$dispatch('filter', { field: 'type', types: value });
			}
		);
	},
});
